import { resource } from 'angular';

export interface ImsObjectResource extends resource.IResource<ImsObjectResource> {
    id: number;
    // TODO typescript complains if we don't have this... but not every ims object has a name
    name: string;
}

export abstract class ImsObject<ResourceType extends ImsObjectResource = any> {
    public readonly imsType: string;
    public resource: ResourceType;

    /* TODO Get rid of this.. this property it's smashed onto the ims object when it's removed via the collection removeObject method.
        in is then passed through the onChanges event once before being removed. There's probably only 1 or 2 places that rely on this property,
        and it should instead be changed to something like -- emit onChanges with a set of changed objects, and a set removed objects. This would make
        it way more clean, clear, and remove the need for smashing properties onto the IMS Objects...
     */
    public removed: boolean | undefined;

    /**
     * The base IMS Object class
     * @param imsType
     * @param resource
     * @param updateTimestamp
     */
    protected constructor(imsType: string, resource: ResourceType) {
        this.imsType = imsType;
        this.applyResourceChange(resource);
    }

    get id(): number {
        return this.resource.id;
    }

    set id(value: number) {
        this.resource.id = value;
    }

    /**
     * @deprecated Not guaranteed after minification
     */
    get uid(): string {
        return this.constructor.name.toLowerCase() + '-' + this.id;
    }

    /**
     * @deprecated Not guaranteed after minification
     * @ngdoc method
     * @name ImsObject.objectType
     * @propertyOf ims.shared.data.service:ImsObject
     * @description
     * The type of object this is an instance of.
     */
    get objectType(): string {
        return this.constructor.name;
    }

    /**
     * @ngdoc method
     * @name ImsObject.name
     * @propertyOf ims.shared.data.service:ImsObject
     * @description
     * Attempts to return the ims object's name if available, or returns undefined.
     */
    get name() {
        return this.resource.name;
    }

    /**
     * Used in certain parts of the application to give a more descriptive name
     */
    get labelName() {
        return this.name;
    }

    /**
     * Some subclasses may want to set the label name. Normally this is not allowed.
     * @param value
     */
    set labelName(value: string) {
        throw Error(`Not implemented`);
    }

    /**
     * @ngdoc method
     * @name ImsObject.applyResourceChange
     * @propertyOf ims.shared.data.service:ImsObject
     * @description
     * Updates the ImsObject's resource
     */
    applyResourceChange(resource) {
        if (!this.resource) {
            this.resource = resource;
        } else {
            Object.assign(this.resource, resource);
        }
    }

    /**
     * @ngdoc method
     * @name ImsObject.isLocal
     * @propertyOf ims.shared.data.service:ImsObject
     * @description
     * Returns whether or not this IMSObject is a 'local' object (id < 0)
     */
    isLocal() {
        return this.id !== null && typeof this.id !== 'undefined' && this.id < 0;
    }
}
